import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDStack } from '@facet-wealth/design';
import { ActionItemList } from './ActionItemList';
import { FeaturedActionItem } from './FeaturedActionItem';

const useStyles = buildUseStyles('FeaturedPillar', (theme) => ({
  container: {
    position: 'relative',
  },
  dashedLineContainer: {
    position: 'absolute',
    padding: theme.spacing(2.5),
    height: '100%',
  },
  dashedLine: {
    top: 0,
    bottom: 0,
    left: '24px',
    borderLeft: '1px dashed #ccc',
    height: '100%',
  },
}));

export const FeaturedPillar = ({ resource: pillarResource, onClickActionItem, prePlan }) => {
  const classes = useStyles();

  const actionItemCollection = pillarResource.attr('actionItems');
  const [firstActionItem] = actionItemCollection;

  if (!firstActionItem) {
    return null;
  }

  return (
    <div className={classes.container}>
      <FDStack direction={'column'} spacing={2}>
        {prePlan && (
        <div className={classes.dashedLineContainer}>
          <div className={classes.dashedLine} />
        </div>
        )}
        <FeaturedActionItem
          pillarResource={pillarResource}
          actionItemResource={firstActionItem}
          onClick={onClickActionItem}
        />
        <ActionItemList onClickActionItem={onClickActionItem} collection={actionItemCollection} pillarResource={pillarResource} prePlan={prePlan} />
      </FDStack>
    </div>
  );
};

FeaturedPillar.defaultProps = {
};

FeaturedPillar.propTypes = {
  resource: PropTypes.object.isRequired,
  onClickActionItem: PropTypes.func.isRequired,
  prePlan: PropTypes.bool.isRequired,
};
